export default {"src":"/_next/static/media/paleo-logo.20c78c69.svg","height":164,"width":189};